// B1 - Ünite 5: Modal Verbs - Obligation & Advice
// Hedef: Must, Have to, Should, Need to

export const B1_UNIT_5 = {
  'B1-U5-L1': {
    id: 'B1-U5-L1',
    title: 'Must / Mustn\'t (Zorunluluk)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Must - Zorunluluk',
          explanation: 'Must güçlü bir zorunluluk ifade eder. Kural, yasa veya güvenlik gereklilikleri için kullanılır.',
          table: {
            headers: ['Yapı', 'Örnek', 'Türkçesi'],
            rows: [
              ['must + fiil', 'You must fasten your seatbelt.', 'Kemerinizi bağlamalısınız.'],
              ['must + fiil', 'Passengers must follow safety rules.', 'Yolcular güvenlik kurallarına uymalı.'],
              ['must + fiil', 'We must check the cabin before takeoff.', 'Kalkıştan önce kabini kontrol etmeliyiz.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '🚫 Mustn\'t - Yasak',
          explanation: 'Mustn\'t yasakları ifade eder. "Yapmamalısın" değil, "yasak" anlamındadır.',
          table: {
            headers: ['Yasak', 'Türkçesi'],
            rows: [
              ['You mustn\'t smoke on the aircraft.', 'Uçakta sigara içemezsiniz. (yasak)'],
              ['Passengers mustn\'t leave bags unattended.', 'Yolcular çantalarını başıboş bırakamaz.'],
              ['You mustn\'t unfasten your seatbelt during turbulence.', 'Türbülans sırasında kemerinizi açamazsınız.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Must = iç zorunluluk/kural | Mustn\'t = YASAK (don\'t have to ile karıştırmayın!)'
        },
        {
          type: 'vocabulary',
          title: '✈️ Must/Mustn\'t ile Güvenlik',
          words: [
            { en: 'You must remain seated.', tr: 'Oturumunuzu korumalısınız.', pronunciation: '' },
            { en: 'You must turn off electronic devices.', tr: 'Elektronik cihazları kapatmalısınız.', pronunciation: '' },
            { en: 'You mustn\'t block the aisles.', tr: 'Koridorları tıkayamazsınız.', pronunciation: '' },
            { en: 'You mustn\'t tamper with smoke detectors.', tr: 'Duman dedektörlerine dokunamazsınız.', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'You _____ fasten your seatbelt during takeoff.',
          options: ['must', 'mustn\'t', 'don\'t have to', 'shouldn\'t'],
          correct: 'must',
          explanation: 'Zorunluluk = must'
        },
        {
          type: 'multipleChoice',
          question: 'You _____ smoke on the aircraft.',
          options: ['mustn\'t', 'must', 'don\'t have to', 'should'],
          correct: 'mustn\'t',
          explanation: 'Yasak = mustn\'t'
        },
        {
          type: 'fillInBlank',
          sentence: 'Passengers _____ follow the crew\'s instructions.',
          answer: 'must',
          hint: 'Zorunluluk = must'
        },
        {
          type: 'fillInBlank',
          sentence: 'You _____ leave your bag in the aisle. (yasak)',
          answer: 'mustn\'t',
          hint: 'Yasak = mustn\'t'
        },
        {
          type: 'matching',
          instruction: 'Doğru modal fiili seçin',
          pairs: [
            { left: 'Fasten seatbelt (zorunlu)', right: 'must' },
            { left: 'Smoking (yasak)', right: 'mustn\'t' },
            { left: 'Follow safety rules (zorunlu)', right: 'must' }
          ]
        }
      ]
    }
  },
  'B1-U5-L2': {
    id: 'B1-U5-L2',
    title: 'Have to / Don\'t have to',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Have to - Dış Zorunluluk',
          explanation: 'Have to dışarıdan gelen zorunlulukları ifade eder (kural, yönetmelik). Must\'tan farklı olarak tüm zamanlarda kullanılabilir.',
          table: {
            headers: ['Şahıs', 'Have to', 'Örnek'],
            rows: [
              ['I/You/We/They', 'have to', 'I have to attend the briefing.'],
              ['He/She/It', 'has to', 'She has to wear the uniform.'],
              ['Past', 'had to', 'We had to delay the flight.'],
              ['Future', 'will have to', 'You will have to show your ID.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✓ Don\'t have to - Zorunlu Değil',
          explanation: 'Don\'t have to "zorunlu değil, ama yapabilirsin" anlamındadır. Mustn\'t\'tan çok farklı!',
          table: {
            headers: ['Cümle', 'Anlam'],
            rows: [
              ['You don\'t have to wear a tie.', 'Kravat takmak zorunda değilsin (ama takabilirsin).'],
              ['Passengers don\'t have to check in online.', 'Online check-in zorunlu değil.'],
              ['You don\'t have to speak Turkish.', 'Türkçe bilmek zorunlu değil.']
            ]
          }
        },
        {
          type: 'tip',
          content: '⚠️ MUSTN\'T = YASAK! | DON\'T HAVE TO = Zorunlu değil (seçim var)'
        },
        {
          type: 'grammar',
          title: '✈️ Havacılıkta Have to',
          table: {
            headers: ['Durum', 'Cümle'],
            rows: [
              ['Kural', 'Crew members have to pass medical exams.'],
              ['Zorunlu değil', 'You don\'t have to buy duty-free.'],
              ['Geçmiş', 'We had to divert to another airport.'],
              ['Gelecek', 'Passengers will have to wait.']
            ]
          }
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Crew members _____ attend safety training.',
          options: ['have to', 'don\'t have to', 'mustn\'t', 'shouldn\'t'],
          correct: 'have to',
          explanation: 'Dış zorunluluk = have to'
        },
        {
          type: 'multipleChoice',
          question: 'You _____ bring food. We serve meals on board.',
          options: ['don\'t have to', 'mustn\'t', 'have to', 'must'],
          correct: 'don\'t have to',
          explanation: 'Zorunlu değil = don\'t have to'
        },
        {
          type: 'multipleChoice',
          question: 'She _____ wear the uniform at work.',
          options: ['has to', 'have to', 'don\'t have to', 'must'],
          correct: 'has to',
          explanation: 'He/She = has to'
        },
        {
          type: 'fillInBlank',
          sentence: 'Yesterday we _____ (have to) delay the flight.',
          answer: 'had to',
          hint: 'Geçmiş zaman: had to'
        },
        {
          type: 'matching',
          instruction: 'Mustn\'t vs Don\'t have to',
          pairs: [
            { left: 'Smoking is forbidden', right: 'mustn\'t smoke' },
            { left: 'Online check-in is optional', right: 'don\'t have to check in online' },
            { left: 'Running in the aisle is forbidden', right: 'mustn\'t run' }
          ]
        }
      ]
    }
  },
  'B1-U5-L3': {
    id: 'B1-U5-L3',
    title: 'Should / Shouldn\'t (Tavsiye)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Should - Tavsiye',
          explanation: 'Should tavsiye vermek için kullanılır. Must kadar güçlü değildir.',
          table: {
            headers: ['Yapı', 'Örnek', 'Türkçesi'],
            rows: [
              ['should + fiil', 'You should arrive early.', 'Erken gelmelisin.'],
              ['should + fiil', 'Passengers should keep valuables with them.', 'Yolcular değerli eşyalarını yanlarında tutmalı.'],
              ['should + fiil', 'You should drink water during the flight.', 'Uçuş sırasında su içmelisiniz.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 Shouldn\'t - Olumsuz Tavsiye',
          explanation: 'Shouldn\'t "yapmamalısın" (tavsiye) anlamındadır. Mustn\'t kadar güçlü değildir.',
          table: {
            headers: ['Tavsiye', 'Türkçesi'],
            rows: [
              ['You shouldn\'t drink too much alcohol.', 'Çok alkol içmemelisin.'],
              ['You shouldn\'t wear tight shoes.', 'Dar ayakkabı giymemelisin.'],
              ['Passengers shouldn\'t sleep during landing.', 'Yolcular iniş sırasında uyumamalı.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Should = tavsiye (zorunlu değil) | Must = zorunluluk'
        },
        {
          type: 'grammar',
          title: '✈️ Mülakatta Should',
          table: {
            headers: ['Tavsiye', 'Açıklama'],
            rows: [
              ['You should research the company.', 'Şirketi araştırmalısın.'],
              ['You should dress professionally.', 'Profesyonel giyinmelisin.'],
              ['You shouldn\'t arrive late.', 'Geç kalmamalısın.'],
              ['You shouldn\'t speak negatively about past employers.', 'Eski işverenler hakkında olumsuz konuşmamalısın.']
            ]
          }
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'You _____ research the airline before the interview.',
          options: ['should', 'must', 'have to', 'mustn\'t'],
          correct: 'should',
          explanation: 'Tavsiye = should'
        },
        {
          type: 'multipleChoice',
          question: 'You _____ be nervous. Just be yourself.',
          options: ['shouldn\'t', 'mustn\'t', 'don\'t have to', 'should'],
          correct: 'shouldn\'t',
          explanation: 'Olumsuz tavsiye = shouldn\'t'
        },
        {
          type: 'fillInBlank',
          sentence: 'Passengers _____ drink plenty of water.',
          answer: 'should',
          hint: 'Tavsiye = should'
        },
        {
          type: 'fillInBlank',
          sentence: 'You _____ eat too much before a flight. (olumsuz tavsiye)',
          answer: 'shouldn\'t',
          hint: 'Olumsuz tavsiye = shouldn\'t'
        },
        {
          type: 'matching',
          instruction: 'Should vs Must',
          pairs: [
            { left: 'Fasten seatbelt (kural)', right: 'must' },
            { left: 'Drink water (tavsiye)', right: 'should' },
            { left: 'Research the company (tavsiye)', right: 'should' }
          ]
        }
      ]
    }
  },
  'B1-U5-L4': {
    id: 'B1-U5-L4',
    title: 'Need to / Don\'t need to',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Need to - Gereklilik',
          explanation: 'Need to "have to" ye benzer, gereklilik ifade eder.',
          table: {
            headers: ['Yapı', 'Örnek', 'Türkçesi'],
            rows: [
              ['need to + fiil', 'I need to check the emergency exits.', 'Acil çıkışları kontrol etmem gerekiyor.'],
              ['needs to + fiil', 'She needs to update her passport.', 'Pasaportunu yenilemesi gerekiyor.'],
              ['needed to + fiil', 'We needed to rebook the passenger.', 'Yolcuyu yeniden rezerve etmemiz gerekti.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✓ Don\'t need to / Needn\'t - Gerekli Değil',
          explanation: 'Don\'t need to veya needn\'t "gerekli değil" anlamındadır.',
          table: {
            headers: ['Cümle', 'Anlam'],
            rows: [
              ['You don\'t need to worry.', 'Endişelenmene gerek yok.'],
              ['You needn\'t bring a blanket.', 'Battaniye getirmene gerek yok.'],
              ['Passengers don\'t need to print boarding passes.', 'Yolcuların biniş kartı basması gerekmiyor.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Need to ≈ Have to | Don\'t need to ≈ Don\'t have to (ikisi de "gerekli değil")'
        },
        {
          type: 'vocabulary',
          title: '✈️ Need to Kullanımları',
          words: [
            { en: 'You need to show your ID.', tr: 'Kimliğinizi göstermeniz gerekiyor.', pronunciation: '' },
            { en: 'We need to board now.', tr: 'Şimdi binmemiz gerekiyor.', pronunciation: '' },
            { en: 'You don\'t need to stand up yet.', tr: 'Henüz kalkmanıza gerek yok.', pronunciation: '' },
            { en: 'You needn\'t rush.', tr: 'Acele etmenize gerek yok.', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I _____ check the cabin before landing.',
          options: ['need to', 'needn\'t', 'don\'t need to', 'shouldn\'t'],
          correct: 'need to',
          explanation: 'Gereklilik = need to'
        },
        {
          type: 'multipleChoice',
          question: 'You _____ bring food. We serve meals.',
          options: ['don\'t need to', 'need to', 'must', 'should'],
          correct: 'don\'t need to',
          explanation: 'Gerekli değil = don\'t need to'
        },
        {
          type: 'fillInBlank',
          sentence: 'She _____ (need to) renew her visa.',
          answer: 'needs to',
          hint: 'She = needs to'
        },
        {
          type: 'fillInBlank',
          sentence: 'You _____ worry. Everything is fine.',
          answer: 'needn\'t',
          hint: 'Gerekli değil = needn\'t / don\'t need to'
        }
      ]
    }
  },
  'B1-U5-L5': {
    id: 'B1-U5-L5',
    title: 'Uygulama: Kural ve Tavsiye',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Modal Karşılaştırma Özeti',
          table: {
            headers: ['Modal', 'Anlam', 'Güç'],
            rows: [
              ['must', 'Zorunlu (iç/kural)', '⭐⭐⭐⭐'],
              ['mustn\'t', 'YASAK', '⭐⭐⭐⭐'],
              ['have to', 'Zorunlu (dış)', '⭐⭐⭐'],
              ['don\'t have to', 'Zorunlu değil', '⭐'],
              ['should', 'Tavsiye', '⭐⭐'],
              ['shouldn\'t', 'Olumsuz tavsiye', '⭐⭐'],
              ['need to', 'Gerekli', '⭐⭐⭐'],
              ['don\'t need to', 'Gerekli değil', '⭐']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Kuralları',
          table: {
            headers: ['Kural', 'Tavsiye'],
            rows: [
              ['You must fasten your seatbelt.', 'You should drink water.'],
              ['You mustn\'t smoke.', 'You shouldn\'t sleep during landing.'],
              ['You have to turn off phones.', 'You should arrive early.'],
              ['You don\'t have to eat.', 'You shouldn\'t eat too much.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakatta: "What MUST a cabin crew member do?" vs "What SHOULD candidates do?" farkını bilin!'
        },
        {
          type: 'vocabulary',
          title: '🎤 Mülakat Tavsiyeler',
          words: [
            { en: 'You should research the airline.', tr: 'Havayolunu araştırmalısın.', pronunciation: '' },
            { en: 'You must be on time.', tr: 'Zamanında olmalısın.', pronunciation: '' },
            { en: 'You shouldn\'t speak negatively.', tr: 'Olumsuz konuşmamalısın.', pronunciation: '' },
            { en: 'You don\'t have to be perfect.', tr: 'Mükemmel olmak zorunda değilsin.', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Safety rules: Passengers _____ fasten seatbelts.',
          options: ['must', 'should', 'don\'t have to', 'need'],
          correct: 'must',
          explanation: 'Güvenlik kuralı = must'
        },
        {
          type: 'multipleChoice',
          question: 'It\'s a good idea: You _____ drink water.',
          options: ['should', 'must', 'have to', 'mustn\'t'],
          correct: 'should',
          explanation: 'Tavsiye = should'
        },
        {
          type: 'multipleChoice',
          question: 'It\'s optional: You _____ buy duty-free.',
          options: ['don\'t have to', 'mustn\'t', 'must', 'should'],
          correct: 'don\'t have to',
          explanation: 'Zorunlu değil = don\'t have to'
        },
        {
          type: 'multipleChoice',
          question: 'It\'s forbidden: You _____ smoke.',
          options: ['mustn\'t', 'don\'t have to', 'shouldn\'t', 'needn\'t'],
          correct: 'mustn\'t',
          explanation: 'Yasak = mustn\'t'
        },
        {
          type: 'speaking',
          instruction: 'Bu kuralları okuyun:',
          phrases: [
            'You must fasten your seatbelt during takeoff.',
            'You shouldn\'t drink too much alcohol.',
            'You don\'t have to bring food.',
            'You mustn\'t smoke on the aircraft.'
          ]
        },
        {
          type: 'matchPairs',
          instruction: 'Doğru modal fiili seçin',
          pairs: [
            { left: 'Zorunlu kural', right: 'must' },
            { left: 'Yasak', right: 'mustn\'t' },
            { left: 'Tavsiye', right: 'should' },
            { left: 'Seçime bağlı', right: 'don\'t have to' }
          ]
        }
      ]
    }
  },
  'B1-U5-EXAM': {
    id: 'B1-U5-EXAM',
    title: 'Ünite 5 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'Passengers _____ fasten their seatbelts during takeoff.',
        options: ['must', 'should', 'don\'t have to', 'shouldn\'t'],
        correct: 'must',
        explanation: 'Güvenlik kuralı = must'
      },
      {
        type: 'multipleChoice',
        question: 'You _____ smoke on the aircraft.',
        options: ['mustn\'t', 'don\'t have to', 'shouldn\'t', 'needn\'t'],
        correct: 'mustn\'t',
        explanation: 'Yasak = mustn\'t'
      },
      {
        type: 'multipleChoice',
        question: 'You _____ bring food. We serve meals.',
        options: ['don\'t have to', 'mustn\'t', 'must', 'should'],
        correct: 'don\'t have to',
        explanation: 'Zorunlu değil = don\'t have to'
      },
      {
        type: 'multipleChoice',
        question: 'You _____ research the company before the interview.',
        options: ['should', 'must', 'mustn\'t', 'don\'t have to'],
        correct: 'should',
        explanation: 'Tavsiye = should'
      },
      {
        type: 'multipleChoice',
        question: 'She _____ wear the uniform at work.',
        options: ['has to', 'have to', 'must to', 'should to'],
        correct: 'has to',
        explanation: 'He/She = has to'
      },
      {
        type: 'fillInBlank',
        sentence: 'You _____ drink too much alcohol. (olumsuz tavsiye)',
        answer: 'shouldn\'t',
        hint: 'Olumsuz tavsiye = shouldn\'t'
      },
      {
        type: 'fillInBlank',
        sentence: 'Passengers _____ (need to) show their ID.',
        answer: 'need to',
        hint: 'Gereklilik = need to'
      },
      {
        type: 'matchPairs',
        instruction: 'Modal fiilleri eşleştirin',
        pairs: [
          { left: 'must', right: 'zorunluluk' },
          { left: 'mustn\'t', right: 'yasak' },
          { left: 'should', right: 'tavsiye' },
          { left: 'don\'t have to', right: 'zorunlu değil' }
        ]
      }
    ]
  }
};

export default B1_UNIT_5;
